export default __webpack_public_path__ + "static/media/feather _ bag.3fbec60a.svg";